// extracted by mini-css-extract-plugin
export default {"wrapper":"cookies_wrapper__Wqeks","card":"cookies_card__GVZvq","section":"cookies_section__bkd26"};